{
  "MACROS": {
    "HEADER": "Macros",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "HEADER_BTN_TXT": "Add a new macro",
    "HEADER_BTN_TXT_SAVE": "Save macro",
    "LOADING": "Fetching macros",
    "ERROR": "Something went wrong. Please try again",
    "ORDER_INFO": "Macros will run in the order you add your actions. You can rearrange them by dragging them by the handle beside each node.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Macro name",
          "PLACEHOLDER": "Enter a name for your macro",
          "ERROR": "Name is required for creating a macro"
        },
        "ACTIONS": {
          "LABEL": "Действия"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro added successfully",
        "ERROR_MESSAGE": "Unable to create macro, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Име",
        "CREATED BY": "Created by",
        "LAST_UPDATED_BY": "Last updated by",
        "VISIBILITY": "Visibility"
      },
      "404": "No macros found"
    },
    "DELETE": {
      "TOOLTIP": "Delete macro",
      "CONFIRM": {
        "MESSAGE": "Сигурни ли сте за изтриването ",
        "YES": "Да, изтрий",
        "NO": "No"
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the macro. Please try again later"
      }
    },
    "EDIT": {
      "TOOLTIP": "Edit macro",
      "API": {
        "SUCCESS_MESSAGE": "Macro updated successfully",
        "ERROR_MESSAGE": "Could not update Macro, Please try again later"
      }
    },
    "EDITOR": {
      "START_FLOW": "Start Flow",
      "END_FLOW": "End Flow",
      "LOADING": "Fetching macro",
      "ADD_BTN_TOOLTIP": "Add new action",
      "DELETE_BTN_TOOLTIP": "Delete Action",
      "VISIBILITY": {
        "LABEL": "Macro Visibility",
        "GLOBAL": {
          "LABEL": "Public",
          "DESCRIPTION": "This macro is available publicly for all agents in this account."
        },
        "PERSONAL": {
          "LABEL": "Private",
          "DESCRIPTION": "This macro will be private to you and not be available to others."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Execute",
      "PREVIEW": "Preview Macro",
      "EXECUTED_SUCCESSFULLY": "Macro executed successfully"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Изисква се стойност",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "Стойността трябва да е между 0 и 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Присвояване на екип",
      "ASSIGN_AGENT": "Присвояване на оператор",
      "ADD_LABEL": "Добавяне на етикет",
      "REMOVE_LABEL": "Премахване на етикет",
      "REMOVE_ASSIGNED_TEAM": "Премахване на присвоения екип",
      "SEND_EMAIL_TRANSCRIPT": "Изпращане на имейл транскрипт",
      "MUTE_CONVERSATION": "Заглушаване на разговор",
      "SNOOZE_CONVERSATION": "Отлагане на разговор",
      "RESOLVE_CONVERSATION": "Разрешаване на разговор",
      "SEND_ATTACHMENT": "Изпращане на прикачен файл",
      "SEND_MESSAGE": "Изпращане на съобщение",
      "CHANGE_PRIORITY": "Промяна на приоритета",
      "ADD_PRIVATE_NOTE": "Добавяне на лична бележка",
      "SEND_WEBHOOK_EVENT": "Изпращане на webhook събитие"
    },
    "ACTION_VALUES": {
      "SELF": "Аз"
    }
  }
}
